import React from "react";
import BillImg from "../../../styles/img/Paybill_icon.png";

export const BillIcon = () => {
  return (
    <>
      <img className="df-w-42" src={BillImg} />
    </>
  );
};
